import { render, staticRenderFns } from "./stationInfo.vue?vue&type=template&id=5619c240&scoped=true"
import script from "./stationInfo.vue?vue&type=script&lang=js"
export * from "./stationInfo.vue?vue&type=script&lang=js"
import style0 from "./stationInfo.vue?vue&type=style&index=0&id=5619c240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619c240",
  null
  
)

export default component.exports